<template>
  <svg
    v-bind="$attrs"
    class="svg-icon"
    :style="getStyle"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <use :xlink:href="symbolId" />
  </svg>
</template>

<script setup>
import { computed } from 'vue';
// 引入插件的客户端脚本，用于注入symbol
import 'virtual:svg-icons-register';

// 组件名称
defineOptions({
  name: 'SvgIcon',
});

const props = defineProps({
  prefix: {
    type: String,
    default: 'svg-icon',
  },
  name: {
    type: String,
    required: true, // SVG文件的文件名（不含后缀）
  },
  size: {
    type: [Number, String],
    default: 16, // 图标默认尺寸
  },
});

// 生成symbolId：#svg-icon-xxx（和vite.config.js的symbolId格式完全匹配）
const symbolId = computed(() => `#${props.prefix}-${props.name}`);

// 处理图标尺寸样式
const getStyle = computed(() => {
  const size = `${props.size}`.replace('px', ''); // 兼容带px和不带px的输入
  return {
    width: `${size}px`,
    height: `${size}px`,
    color: 'inherit',
  };
});
</script>

<style lang="less" scoped>
.svg-icon {
  overflow: hidden;
  fill: currentcolor;
  vertical-align: -0.15em;
  display: inline-block;
}
</style>
